import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    width: '100%',
    height: '8vh',
    background: '#C4C4C4',
    overflowX: 'hidden',
    position: 'fixed',
    marginTop: '19vh',
    zIndex: '99',
    boxSizing: 'border-box',
  },
  rootModal: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    width: '100%',
    height: '8vh',
    background: '#C4C4C4',
    overflowX: 'hidden',
    position: 'relative',
    zIndex: '99',
    boxSizing: 'border-box',
  },
  buttonSubmit: {
    cursor: 'pointer',
    width: '150px',
    backgroundColor: '#026894',
    color: '#fff',
    height: '32px',
    boxShadow: 'none',
    border: 'none',
    borderRadius: '4px',
    textTransform: 'capitalize',
    fontSize: '14px',
    marginRight: 0,
    '&:hover': {
      backgroundColor: '#064561',
    },
  },
  buttonExtra: {
    cursor: 'pointer',
    backgroundColor: '#026894',
    color: '#fff',
    height: '32px',
    boxShadow: 'none',
    border: 'none',
    borderRadius: '4px',
    textTransform: 'capitalize',
    fontSize: '14px',
    marginRight: 0,
    minWidth: '120px',
    '&:hover': {
      backgroundColor: '#064561',
    },
  },
  button: {
    cursor: 'pointer',
    minWidth: '100px',
    width: 'auto',
    paddingLeft: '16px',
    paddingRight: '16px',
    backgroundColor: '#EAEAEA',
    color: '#000000',
    height: '32px',
    boxShadow: 'none',
    border: 'none',
    borderRadius: '4px',
    textTransform: 'capitalize',
    fontSize: '14px',
    marginRight: 0,
  },
  link: {
    color: '#000000',
    textTransform: 'capitalize',
    fontSize: '14px',
    textDecoration: 'none',
  },
  classes: {
    fontSize: '25px',
    color: '#000000',
    fontWeight: 'bold',
    marginLeft: '43%',
  },
  divButton: {
    justifyContent: 'flex-end',
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    gap: '12px',
    paddingRight: '16px',
    flexShrink: 0,
    zIndex: 2,
  },
  /** Título centralizado na barra inteira; botões ficam à direita (sem empilhar). */
  title: {
    position: 'absolute',
    left: '50%',
    transform: 'translateX(-50%)',
    fontSize: '22px',
    color: '#000000',
    fontWeight: 'bold',
    textAlign: 'center',
    maxWidth: '55%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    pointerEvents: 'none',
    zIndex: 1,
  },
}));

export default useStyles;
